﻿import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LanguageService } from '../core/language/language.service';
import { MenuItem } from '../core/models/administration/menu-item';
import { GlobalEventsManagerService } from '../core/services/global-events-manager.service';
import { SecurityService } from '../core/services/security.service';
import { ToastService } from '../core/toast/toast.service';
import { SharedService } from '../shared/shared.service';
import { Location } from '@angular/common';
import { CONFIG } from '../core/config';
import { window } from 'rxjs/operators';

@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements OnInit {
    public isExpanded = false;
    public isLoggedIn: boolean = false;
    public menuItems: MenuItem[];
    private activeChildUrl: string;
    private activeParentMenuId: number;
    public languageID: number;
    public reloadedUrl: string;
    public username: string;

    public currentUser: any;
    public showDropdown: boolean = true;

    private activeStaticParentRoute: string;
    private activeStaticRoute: string;

    constructor(private _router: Router,
        private activatedRoute: ActivatedRoute,
        private sharedService: SharedService,
        private _languageService: LanguageService,
        private _securityService: SecurityService,
        private _toastService: ToastService,
        private _location: Location,
        private _eventsManagerService: GlobalEventsManagerService) {
        this.activeChildUrl = "";
        this.activeParentMenuId = 0;
        this.menuItems = [];
        this.languageID = this._languageService.selectedLanguageId;
        this.reloadedUrl = "";
        this.isLoggedIn = this._securityService.isLoggedIn;      

        this._securityService.currentUser.subscribe(x => {
            this.currentUser = x;
            if (this.currentUser != null) {
                if (this._securityService.getCurrentUserProfileId() == CONFIG.profileEnum.AnonymousCitizen) {
                    this.showDropdown = false;
                }
                else {
                    this.showDropdown = true;
                }
                this.GetNavMenu();
            }
            else {
                this.menuItems = [];

                this.setSelectedStaticRoute();
            }

            this.setLoggedUserName();

            this.activeChildUrl = "";
            this.activeParentMenuId = 0;
            this.reloadedUrl = "";           
        });
    }

    ngOnInit(): void {
    }

    collapse() {
        this.isExpanded = false;
    }

    toggle() {
        this.isExpanded = !this.isExpanded;
    }

    GetNavMenu() {
        this.sharedService.getNavMenu(this.languageID).subscribe(data => {
            this.menuItems = data;     
        });
    }

    setActiveRoute(menuItem: any) {
        this.activeChildUrl = menuItem.url;
        this.activeParentMenuId = menuItem.parentID;
    }

    setLoggedUserName() {
        this.username = this._securityService.getCurrentUsername();
    }

    logout() {
        this._securityService.logout();
        this.isLoggedIn = this._securityService.isLoggedIn;
        this.setLoggedUserName();

        //let msg = "uspjesna_odjava";
        //msg = this._languageService.translate(msg);
        //this._toastService.activate(msg, "alert-successToast");
    }

    setSelectedStaticRoute() {
        if (this.currentUser == null) {
            let currentRoute = this._location.path();

            switch (currentRoute) {
                case '/home':
                    this.setActiveRouteStatic('pocetna', '');
                    break;
                case '/complaints/all-complaints':
                    this.setActiveRouteStatic('prituzbe', 'sve_prituzbe');
                    break;
                case '/complaints/statistic':
                    this.setActiveRouteStatic('prituzbe', 'statistika');
                    break;
                case '/online-debates/online-debates-list':
                    this.setActiveRouteStatic('javne_rasprave', 'online_јavne_rasprave');
                    break;
                case '/offline-debates/offline-debates-list':
                    this.setActiveRouteStatic('javne_rasprave', 'offline_javne_rasprave');
                    break;
                case '/debate/statistics':
                    this.setActiveRouteStatic('javne_rasprave', 'statistika');
                    break;
                case '/public-sessions/session-list':
                    this.setActiveRouteStatic('sjednice', 'sve_sjednice');
                    break;
                case '/public-sessions/statistic':
                    this.setActiveRouteStatic('sjednice', 'statistika');
                    break;
                case '/questions/council-members-questions/mayor-question-details':
                    this.setActiveRouteStatic('pitanja', 'pitanja_za_nacelnika');
                    break;
                case '/questions/council-members-questions/council-member-question-list':
                    this.setActiveRouteStatic('pitanja', 'pitanja_za_odbornika');
                    break;
                case '/questions/organizational-unit-questions/organizational-unit-questions-list':
                    this.setActiveRouteStatic('pitanja', 'pitanja_za_organizacione_jedinice');
                    break;
                case '/questions/council-members-questions/statistic':
                    this.setActiveRouteStatic('pitanja', 'statistika');
                    break;
                default:
                    this.setActiveRouteStatic('pocetna', '');
                    break;
            }
        }
    }

    setActiveRouteStatic(parentRoute, route) {
        this.activeStaticParentRoute = parentRoute;
        this.activeStaticRoute = route;
    }
}
